
import BaseCard from '@/components/base/BaseCard'
import {Component} from 'vue-property-decorator'

@Component
export default class BaseCardContainer extends BaseCard {}
